import planok from "./planok.svg";

export default function PlanOkIcon() {
  return (
    <img src={planok} />
  );
}